import { List } from '@services/member/list/list.types';
import { useGetMembersEditionMutation, useGetMembersEditionExportMutation} from '@services/member/member/member.endpoints';
import { MemberTable } from '@services/member/member/member.types';
import { useGetStateCodesMutation } from '@services/member/list/list.endpoints';
import { PaginationMetadata } from '@services/providers/cosem.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useEffect, useState } from 'react';

export const useMemberEditionPageVM = () => {

    const [totalMembers, setTotalMembers] = useState<number>(0);
    const [stateCodes, setStateCodes] = useState<List[]>([]);
    const columnHelper = createColumnHelper<MemberTable>();

    const [getStateCodes, { isSuccess: isGetStateCodesSuccess, isLoading: isGetStateCodesLoading, data: stateCodesData }] = useGetStateCodesMutation();
    
    useEffect(() => {
        getStateCodes(undefined);
    }, []);

    useEffect(() => {
        if(isGetStateCodesLoading) return;
        if (isGetStateCodesSuccess && stateCodesData) {
            setStateCodes(stateCodesData.data);
        }
    }, [isGetStateCodesSuccess]);
   

    const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalMembers(metadata.total);
        }
    };


    return {
        handleMetadata,
        columnHelper,
        useGetMembersEditionMutation,
        totalMembers,
        stateCodes,
        useGetMembersEditionExportMutation,
    };
};
